module.exports = __webpack_public_path__ + "img/house.bbbd7f9f.png";